import React from "react"
import PropTypes from "prop-types"

import BadgeIcon from './BadgeIcon'

class ProfileBadgeSection extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit",
      badges: [],
      allBadges: [],
      showAllBadges: false,
    }

    this.renderBadges = this.renderBadges.bind(this)
    this.renderEmptyBadges = this.renderEmptyBadges.bind(this)
    this.showAllBadgesButton = this.showAllBadgesButton.bind(this)
  }



  componentDidMount() {

    let data = {
      user_id: this.props.userId
    }
    $.ajax({
      url: `../get_profile_badges`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          badges: JSON.parse(data.data.badges),
          allBadges: JSON.parse(data.data.allBadges),
          showAllBadges: false
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderBadges() {
    if(this.state.showAllBadges) {
      return this.state.allBadges.map((badge, i) => {
        return <BadgeIcon badge={badge} key={i} badgeEarned={true} closeIcon={this.props.closeIcon}/>
      })
    }
    return this.state.badges.map((badge, i) => {
      return <BadgeIcon badge={badge} key={i} badgeEarned={true} closeIcon={this.props.closeIcon}/>
    })
  }

  renderEmptyBadges() {
    let count = this.state.showAllBadges ? (8-this.state.allBadges.length%8) :  (8-this.state.badges.length%8);
    let placeholders = []

    for(let i = 0; i < count; i++){
        placeholders.push(
            <div className="badgePlaceholder" key={i} >
              <div style={{height: 74, width: 74, marginBottom: 5, border: 'solid 6px rgba(255,255,255,.5)', borderWidth: 5, borderRadius: 50}}>
              </div>
            </div>
        )
    }
    return placeholders

  }

  showAllBadgesButton() {
    if(this.props.dashboard === true) {
      return (<button className="small_button_primary" style={{float: 'right', marginBottom: 24, marginTop: 24, fontSize: 20}} onClick={() => this.setState({showAllBadges: !this.state.showAllBadges})}>
        <h3>{this.state.showAllBadges ? "My Badges" : "All Badges"}</h3>
      </button>
      )
    }
    return null
  }

  render() {
    return(
      <div className="lightBlueSection" style={{padding: this.props.width<350?5:20}}>
        <h4 className="sectionHeader">{this.state.showAllBadges ? "All Badges" : "My Badges"}</h4>
        <div style={{minHeight: 200, maxWidth: 350, margin: 'auto'}}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap'}}>
            {this.renderBadges()}
            {this.renderEmptyBadges()}
          </div>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            {this.showAllBadgesButton()}
          </div>
        </div>
      </div>
    )
  }

}


export default ProfileBadgeSection
